import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MediaModel, MediaCategory } from '../media-library.model';
import { WidgetService } from '../../services/widget.service';
import { SnackBarService } from '../../../core/snack-bar.service';

@Component({
  selector: 'app-media-library-modal',
  templateUrl: './media-library-modal.component.html',
  styleUrl: './media-library-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MediaLibraryModalComponent {
  defaultCategory: MediaCategory;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MediaLibraryModalComponent>,
    private widgetService: WidgetService,
    private snackbarService: SnackBarService,
  ) {}

  ngOnInit() {
    this.defaultCategory = this.data.defaultCategory;
  }

  public mediaSelected(result) {
    if (result && result.data) {
      const image = result.data as MediaModel;
      if (image.uri.includes('triggerbee/images/')) {
        this.widgetService.copyMediaCollectionImage(image.uri).subscribe(
          (response) => {
            if (response) {
              result.data.uri = response.uri;
              this.dialogRef.close(result);
            }
          },
          (error) => {
            this.snackbarService.error('campaign.widget.sidebar.media.upload-images.uploading-error');
          },
        );
        return;
      }
    }
    this.dialogRef.close(result);
  }
}
